import { ModelDef } from '../../../common/$models/ModelDef'
import { ModelRecordWorkflowThreadItemRelatedUsers } from './RecordWorkflowThreadItemRelatedUsers'

export const nodeStateOptions = {
  active: '進行中',
  completed: '完了',
  pending: '待機中',
  skipped: 'スキップ',
  upcoming: '予定',
}

const model: ModelDef = {
  tableName: 'record_workflow_thread_items',
  tableLabel: 'ワークフローアイテム',
  primaryKeyColType: 'UUID',
  columns: {
    id: {
      type: 'UUID',
      label: 'ID',
    },
    threadId: {
      type: 'RELATIONSHIP_MANY_TO_ONE',
      label: 'スレッド',
      validate: { notEmpty: true },
      relationshipManyToOne: {
        collectionName: 'record_workflow_threads',
        labelFormatter: (record) =>
          `${record.id} / ${record.targetModelName} - ${record.recordId}`,
        onDeleteDbRestriction: 'CASCADE',
      },
    },
    nodeKey: {
      type: 'STRING',
      label: 'ノードキー',
      validate: { notEmpty: true },
    },
    actionKey: {
      type: 'STRING',
      label: 'アクションキー',
      // validate: { notEmpty: true },
    },
    nodeState: {
      type: 'SELECT',
      label: 'ノードの状態',
      validate: { notEmpty: true },
      selections: () => Object.keys(nodeStateOptions),
      customLabel: (value) => nodeStateOptions[value],
      defaultValue: 'pending',
    },
    comment: {
      type: 'TEXT',
      label: 'コメント',
    },
    routeIndex: {
      type: 'NUMBER',
      label: 'ルート内の順序',
      comment: 'ルート内での表示順序を示す数値',
    },
    // 前後のアイテムとの関係性
    previousItems: {
      type: 'MULTISELECT',
      label: '前のアイテム',
      comment: 'UUID配列として保存',
    },
    nextItems: {
      type: 'MULTISELECT',
      label: '次のアイテム',
      comment: 'UUID配列として保存',
    },
    // 関連ユーザー情報
    relatedUsers: {
      type: 'RELATIONSHIP_ONE_TO_MANY',
      label: '関連ユーザー',
      relationshipOneToMany: {
        collectionName: 'record_workflow_thread_item_related_users',
        fieldName: 'threadItem',
      },
      width: { xs: 48 },
    },
    // メタデータ
    metadata: {
      type: 'JSON',
      label: 'メタデータ',
      groupKey: 'meta',
    },
    actionDefinitionSnapshot: {
      type: 'JSON',
      label: 'アクション定義スナップショット',
      comment: 'アクション実行時点でのワークフロー定義の内容をキャッシュ',
      groupKey: 'meta',
    },
    executedBy: {
      type: 'RELATIONSHIP_MANY_TO_ONE',
      label: '実行者',
      relationshipManyToOne: {
        collectionName: 'directus_users',
        labelFormatter: (record) => `${record.first_name}`,
      },
    },
  },
  formColumnGroups: {
    basic: {
      type: 'tab',
      label: '基本情報',
      order: 10,
    },
    meta: {
      type: 'tab',
      label: 'メタデータ',
      order: 20,
    },
  },
}

export const record_workflow_thread_items = model

export type ModelRecordWorkflowThreadItems = {
  id?: string
  threadId: string
  nodeKey: string
  actionKey: string
  nodeState: 'active' | 'completed' | 'pending' | 'skipped' | 'upcoming'
  routeIndex: number
  previousItems: string[]
  nextItems: string[]
  comment: string
  metadata?: Record<string, unknown>
  actionDefinitionSnapshot?: Record<string, unknown>
  relatedUsers: ModelRecordWorkflowThreadItemRelatedUsers[]
  executedBy?: any
  createdAt?: string
  updatedAt?: string
}
